'use client'

import customAlert from "@/util/customAlert";
import { isIOS } from "@/util/isIOS";
import { registerPush } from "@/util/registerPush";
import { createContext, ReactNode, useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { AuthContext } from "./authContext";

export const WebPushContext = createContext<{}>({})
export default function WebPushProviders({children}: {children: ReactNode}){
    const { user } = useContext(AuthContext)
    // useEffect(()=> {
    //     if(isMobile)
    //         // 모바일 일 때만 실행
    //         if(isIOS()){     
    //             // IOS 용 우선 확인 후 실행
    //             isPushNotificationEnabled()
    //                 .then(isPush=> {
    //                     if(!isPush){
    //                         customAlert('알림 설정이 필요한 사이트 입니다.', 'warning', ()=> {
    //                             registerPush()
    //                         }, { confirmMode: true })
    //                     }
    //                 })
    //         }else{
    //             registerPush()
    //         }
    // }, [isMobile])

    // useEffect(()=> {
    //     registerPush()
    // }, [])
    return (
        <WebPushContext.Provider value={{}}>{children}</WebPushContext.Provider>
    )
}

export async function isPushNotificationEnabled(): Promise<boolean> {
    const permission = Notification.permission;
    if (permission !== "granted") {
        console.log("🔕 알림 권한이 아직 허용되지 않음:", permission);
        return false;
    }

    const register = await navigator.serviceWorker.getRegistration();
    if (!register) {
        console.log("❌ 서비스워커가 등록되지 않음");
        return false;
    }

    const subscription = await register.pushManager.getSubscription();
    if (!subscription) {
        console.log("🚫 푸시 구독이 아직 없음");
        return false;
    }

    console.log("✅ 알림 설정 완료!");
    console.log(subscription);
    return true;
}
